module.exports = __webpack_public_path__ + "ro.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ro.svg
// module id = 779
// module chunks = 0